import styled from "styled-components";
import { PixIcon, theme } from "ui";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.space.x4};
`;

export const Indicator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.space["x1.5"]};
  padding: ${theme.space.x0} ${theme.space.x2};
  height: ${theme.space.x11};
`;

export const Title = styled.h2`
  font-size: ${theme.typography.fontSize.sm.x3};
  font-weight: ${theme.typography.fontWeight["400"]};
`;

export const Icon = styled(PixIcon)``;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space.x1};
`;

export const Label = styled.p`
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["500"]};
  color: ${theme.colors.neutral["550"]};
`;

export const Price = styled.span`
  font-size: ${theme.typography.fontSize.sm.x7};
  font-weight: ${theme.typography.fontWeight["700"]};
  color: ${theme.colors.secondary["230"]};
`;
